import { ApiError, PaginatedResponse } from '@gorila-shared-ui/components';
import { ApiEndpoint } from '../types/api';
import { AttendEventRequest, Event, EventAlarmType, EventCore } from '../types/gptTypes';
import { getRequest, postRequest } from './api';
import { attendEventUrl, getEventsUrl, getEventUrl, gptAlarmTypesUrl } from './urls/gptUrls';

export const getEvents = async (
  page: number = 1,
  search: string = '',
): Promise<{ paginatedResponse?: PaginatedResponse<EventCore>; error?: ApiError }> => {
  const response = await getRequest(getEventsUrl, { queryParams: { page, q: search } });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const getEvent = async (eventId: string): Promise<{ event?: Event; error?: ApiError }> => {
  const response = await getRequest(getEventUrl(eventId), {});
  return {
    event: response?.data,
    error: response?.error,
  };
};

export const attendEvent = async (eventId: string, data: AttendEventRequest): Promise<{ error?: ApiError }> => {
  const response = await postRequest(attendEventUrl(eventId), {
    body: data,
  });

  return {
    error: response?.error,
  };
};

export const getGptAlarmTypes = async (): Promise<{ alarmTypes: EventAlarmType[]; error?: ApiError }> => {
  const response = await getRequest(gptAlarmTypesUrl, undefined, undefined, ApiEndpoint.core);
  return {
    alarmTypes: response?.data,
    error: response?.error,
  };
};
